import React from 'react';
import { createPortal } from 'react-dom';
import Button from '@/components/UI/Button';
import styles from './ConfirmationDialog.module.css';
import { Link } from 'react-router-dom';

interface ConfirmationDialogProps {
	isOpen: boolean;
	title: string;
	message: string;
	confirmText: string;
	cancelText: string;
	onConfirm: () => void;
	onCancel: () => void;
	isLoading?: boolean;
	showFooterText?: boolean;
	footerText?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	isOpen,
	title,
	message,
	confirmText,
	cancelText,
	onConfirm,
	onCancel,
	isLoading = false,
	showFooterText,
	footerText
}) => {
	if (!isOpen) return null;

	const handleBackdropClick = (e: React.MouseEvent) => {
		if (e.target === e.currentTarget) {
			onCancel();
		}
	};

	return createPortal(
		<div className={styles.overlay} onClick={handleBackdropClick}>
			<div className={styles.dialog}>
				<div className={styles.header}>
					<h3 className={styles.title}>{title}</h3>
				</div>

				<div className={styles.body}>
					<p className={styles.message}>{message}</p>
				</div>

				<div className={styles.footer}>
					<div className={styles.footerContent}>
						<Button
							name={cancelText}
							onClick={onCancel}
							color="black"
							background="white"
							className={styles.cancelButton}
							disabled={isLoading}
						/>
						<Button
							name={confirmText}
							onClick={onConfirm}
							color="white"
							background="black"
							className={styles.confirmButton}
							disabled={isLoading}
						/>
					</div>
					{showFooterText && (
						<Link to="/signup" className={styles.navLink}>
							<p className={styles.forgotPass_label}>{footerText}</p>
						</Link>
					)}
				</div>
			</div>
		</div>,
		document.body
	);
};

export default ConfirmationDialog;
